const PROMPT_KEYS = {
    HOTEL_DESCRIPTION: 'HOTEL_DESCRIPTION',
    COMPETITOR_HOTEL_SUGGESTER_WITH_EXCLUSIONS:
        'COMPETITOR_HOTEL_SUGGESTER_WITH_EXCLUSIONS',
};

export default PROMPT_KEYS;
